<template>
  <div ref="target" class="relative">
    <ui-mapbox-map
      :options="{
        accessToken: config.mapbox.token,
        style: MAPBOX_STYLE,
        maxPitch: 0,
        minPitch: 0,
        bounds: WESTERN_AUSTRALIA_BOUNDING_BOX,
        fadeDuration: 0,
        maxZoom: 23,
      }"
    >
      <ui-map-legend v-if="map.created" class="z-[2]" />
      <ui-map-controls v-if="map.created" />
    </ui-mapbox-map>
  </div>
</template>

<script lang="ts" setup>
import { useConfig } from '@/composables';
import { MAPBOX_STYLE, WESTERN_AUSTRALIA_BOUNDING_BOX, useMapStore } from '@/features/hazards';
import { onClickOutside, useResizeObserver } from '@vueuse/core';
import { ref } from 'vue';

const target = ref(null);
const config = useConfig();
const map = useMapStore();

useResizeObserver(target, (entries) => {
  const entry = entries[0];
  const { width, height } = entry.contentRect;
  map.mapElementSize.width = width;
  map.mapElementSize.height = height;
});

onClickOutside(target, () => {
  map.closePopup();
});
</script>

<style>
.mapboxgl-ctrl-top-right {
  display: none;
}
</style>
